import React from 'react';
import ItemTitleValue from './ItemTitleValue';
import { Container } from './Styles';

const ItemTitle = ({
  testId,
  titleText = 'Item Title Text',
  textSize,
  underlineTitle,
  onClick = null,
}) => {
  return (
    <Container
      data-testid={testId}
      textSize={textSize}
      underlineTitle={underlineTitle}
      onClick={onClick}
    >
      <ItemTitleValue labelText={titleText} />
    </Container>
  );
};

export default ItemTitle;
